import { Stack } from '@ekhodealer/ekho-common/rev';

import { SettingsSection } from '@common/components/SettingsSection';
import { SettingsPageContent, type TocItem } from '@common/components/SettingsTableOfContents';

import { CrmForwardingSection } from './CrmForwardingSection';
import { DmsConnectionSection, DmsSyncSettingsSection } from './DmsConnectionSection';

const INTEGRATIONS_TOC: TocItem[] = [
	{ id: 'crm-forwarding', title: 'CRM forwarding' },
	{ id: 'dms-connection', title: 'DMS' },
];

export function IntegrationsSettingsPage(): React.JSX.Element {
	return (
		<SettingsPageContent tocItems={INTEGRATIONS_TOC}>
			<SettingsSection
				title='CRM forwarding'
				description='Forward captured lead data to your CRM via ADF/XML email.'>
				<CrmForwardingSection />
			</SettingsSection>
			<SettingsSection
				title='DMS'
				description='Connect your Dealer Management System to sync inventory and customer data.'
				hideDivider>
				<Stack itemsSpacing='16'>
					<DmsConnectionSection />
					<DmsSyncSettingsSection />
				</Stack>
			</SettingsSection>
		</SettingsPageContent>
	);
}
